import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import data1 from "../../Data/antiCorruptionData1.json";
import data2 from "../../Data/antiCorruptionData2.json";
import data3 from "../../Data/antiCorruptionData3.json";
import data4 from "../../Data/antiCorruptionData4.json";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

export default function AntiCorruption() {
  useSEO(seoConfig.antiCorruption);

  return (
    <section className="licenses antiCorruption">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Противодействие коррупции
      </h1>

      <div>
        <h3 className="about-nii__title antiCorruption__title">
          Нормативные правовые акты в сфере противодействия коррупции
        </h3>
        <Accordion data={data4} />

        <h3 className="about-nii__title antiCorruption__title">
          Локальные акты учреждения
        </h3>
        <Accordion data={data1} />
        <h3 className="about-nii__title antiCorruption__title">
          Формы документов, связанных с противодействием коррупции
        </h3>
        <Accordion data={data2} />

        <h3 className="about-nii__title antiCorruption__title">
          Комиссия по противодействию коррупции
        </h3>
        <Accordion data={data3} />

        <h3 className="about-nii__title antiCorruption__title">
          Обратная связь для сообщений о фактах коррупции
        </h3>

        <p className="dissertation__text">
          Департамент противодействия коррупции Свердловской области
        </p>
        <div className="additional__links">
          <a
            href="tel:+73433707202"
            className="dissertation__text additional__tel"
          >
            +7 (343) 370-72-02
          </a>
        </div>

        <p className="dissertation__text">
          Министерство здравоохранения Свердловской области
        </p>
        <div className="additional__links">
          <a
            href="tel:+73433120302"
            className="dissertation__text additional__tel"
          >
            +7 (343) 312-03-02
          </a>
        </div>

        <p className="dissertation__text">Региональный «телефон доверия»</p>
        <div className="additional__links">
          <a
            href="tel:+78001013384"
            className="dissertation__text additional__tel"
          >
            8 (800) 101-33-84
          </a>
        </div>
      </div>
    </section>
  );
}
